import Switch from '@components/v2/form/Switch/Switch';
import { Stack } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import SettingContainer from '../../SettingContainer';
import { PriceSettingsSectionGeneralSettingsProps } from '../types/GeneralSettings.types';

const PriceSettingsSectionGeneralSettings = ({
  generalSettings,
  handleChangeAndBlur,
}: PriceSettingsSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  return (
    <SettingContainer
      title={translate(LangEnum.GENERAL_SETTINGS_PRICE_SETTINGS)}
      description={LangEnum.GENERAL_SETTINGS_PRICE_SETTINGS_DESCRIPTION}
    >
      <Stack sx={{ gap: 2 }}>
        <Switch
          label={translate(LangEnum.GENERAL_SETTINGS_ENABLE_MARKUP)}
          name="enableMarkup"
          size="medium"
          sx={{ ml: 0 }}
          checked={generalSettings.enableMarkup}
          onChange={(_, checked) => handleChangeAndBlur({ value: checked, name: 'enableMarkup' })}
        />
        <Switch
          label={translate(LangEnum.GENERAL_SETTINGS_VIEW_RETAIL_PRICE_ORDER_FLOW)}
          name="enableRetailPrice"
          size="medium"
          sx={{ ml: 0 }}
          checked={generalSettings.enableRetailPrice}
          onChange={(_, checked) =>
            handleChangeAndBlur({ value: checked, name: 'enableRetailPrice' })
          }
        />
        <Switch
          label={translate(LangEnum.GENERAL_SETTINGS_SHOW_PRODUCTS_WITH_ZERO_WHOLESALE_PRICE)}
          name="showProductsWithZeroWholesalePrice"
          size="medium"
          sx={{ ml: 0 }}
          checked={generalSettings.showProductsWithZeroWholesalePrice}
          onChange={(_, checked) =>
            handleChangeAndBlur({ value: checked, name: 'showProductsWithZeroWholesalePrice' })
          }
        />
      </Stack>
    </SettingContainer>
  );
};

export default PriceSettingsSectionGeneralSettings;
